import { NOTIFICATION_TYPE, showNotificationAction } from 'Modules'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { bgLeadSlice, bgRequestSlice, prepareErrors } from 'Pages/ibro'
import { CONTOUR, getContour } from '@pp/axios'
import { Callback } from 'Src/types/utilTypes'

export class BankGuaranteeChannelNeo implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}

	public work(data: SocketMessage): void {
		const { message } = data
		const request_type = message?.type as SocketMessageTypes
		const id = message?.payload?.request_id
		const status = message?.payload?.success
		// eslint-disable-next-line no-console
		if (getContour() === CONTOUR.DEV || getContour() === CONTOUR.UAT) console.log('ws', message)
		const errors = message?.payload?.errors
		if (
			(request_type === SocketMessageTypes.CHECK_LIMIT ||
				(request_type === SocketMessageTypes.POST_REQUEST && errors) ||
				request_type === SocketMessageTypes.UPDATE_REQUEST) &&
			id
		) {
			this.dispatch(bgRequestSlice.actions.updateStatusItem({ id, status, request_type, errors }))
		}
		if (
			(request_type === SocketMessageTypes.CHECK_STATUS ||
				request_type === SocketMessageTypes.GET_GUARANTEE) &&
			id
		) {
			const { changes } = message.payload
			this.dispatch(
				bgRequestSlice.actions.updateStatusItem({
					id,
					status,
					request_type,
					changes,
					errors,
				})
			)
			if (changes)
				this.dispatch(
					bgRequestSlice.actions.changeSocket({
						change: { ...changes, request_id: id },
						params: null,
					})
				)
		}
		if (request_type === SocketMessageTypes.LEAD_COMPLETE && id) {
			const { shortname, purchasecode, inn } = message.payload
			this.dispatch(
				bgLeadSlice.actions.leadCompleteBg({
					id,
					status,
					info: { shortname, purchasecode, inn },
				})
			)
		}
		if (request_type === SocketMessageTypes.CALCULATE_COMMISSION) {
			const { result, initial_params = null } = message.payload
			this.dispatch(
				bgRequestSlice.actions.setCalculateCommission({
					status,
					change: { ...result, request_id: id },
					params: initial_params,
					errors,
				})
			)
		}
		if (request_type === SocketMessageTypes.GET_BANK_DATA && id) {
			const { result } = message.payload
			if (status)
				this.dispatch(
					bgRequestSlice.actions.changeSocket({ change: { ...result, request_id: id } })
				)
			else {
				this.dispatch(
					showNotificationAction({
						type: NOTIFICATION_TYPE.ERROR,
						message: 'Ошибка при получении банковских реквизитов',
					})
				)
			}
		}
		if (request_type === SocketMessageTypes.SAVE_NEW_SEND_ADDRESS && id) {
			this.dispatch(bgRequestSlice.actions.confirmedChangeSendAddress({ id, status }))
		}
		if (request_type === SocketMessageTypes.CLONE_REQUEST && id) {
			this.dispatch(
				bgRequestSlice.actions.cloneRequestComplete({
					id,
					clone_request_id: message?.payload?.result?.clone_request_id,
				})
			)
		}

		if (request_type === SocketMessageTypes.CURRENT_ELEMENTS && id) {
			this.dispatch(bgRequestSlice.actions.updateItem({ id }))
			if (errors?.length) {
				this.dispatch(
					showNotificationAction({
						type: NOTIFICATION_TYPE.ERROR,
						prepareErrors: prepareErrors(errors),
					})
				)
			}
		}
		if (request_type === SocketMessageTypes.SEND_TO_REWORK && id) {
			this.dispatch(bgRequestSlice.actions.getItemWithCheckStatus(id))
			if (errors?.length) {
				this.dispatch(
					showNotificationAction({
						type: NOTIFICATION_TYPE.ERROR,
						prepareErrors: prepareErrors(errors),
					})
				)
			}
		}
		if (request_type === SocketMessageTypes.UNBLOCK_RELEASE && id) {
			this.dispatch(bgRequestSlice.actions.getItemWithCheckStatus(id))
			if (errors?.length) {
				this.dispatch(
					showNotificationAction({
						type: NOTIFICATION_TYPE.ERROR,
						prepareErrors: prepareErrors(errors),
					})
				)
			}
		}
		if (request_type === SocketMessageTypes.REQUEST_FIELDS_UPDATE) {
			this.dispatch(bgRequestSlice.actions.getItem(message?.payload?.id))
		}
		if (request_type === SocketMessageTypes.GET_TEMPLATE && id) {
			this.dispatch(bgRequestSlice.actions.getItem(id))
		}
	}
}
